import { Env } from '@app/core/interfaces/env.interface';
import { environment as maximProdEnv } from './environment.prod-maxim';
import { Themes } from '@app/core/enums/themes.enum';
import { Store } from '@app/shared/modules/mobile-badge/enums/store.enum';
import { AxiomMapRegion } from '@axiom/material-components/kit/map';

export const environment: Env = {
  ...maximProdEnv,
  apiUrl: 'https://api.taximaxim.ru/client/v1',
  stores: {
    [Store.AppStore]:
      'https://maximru-ios.onelink.me/ttKs?af_r=https%3A%2F%2Fapps.apple.com%2Fapp%2Fmaxim-ru-%25D0%25B7%25D0%25B0%25D0%25BA%25D0%25B0%25D0%25B7-%25D1%2582%25D0%25B0%25D0%25BA%25D1%2581%25D0%25B8-%25D0%25B2-%25D1%2580%25D0%25BE%25D1%2581%25D1%2581%25D0%25B8%25D0%25B8%2Fid6752884875%3Fpt%3D119057982%26ct%3Dtaximaxim_site%26mt%3D8&c=main&pid=taximaxim_site&is_retargeting=true',
    [Store.GooglePlay]:
      'https://maximru-android.onelink.me/LIU9?af_r=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.maxim.internal%26referrer%3Dutm_source%253Dtaximaxim%2526utm_medium%253Dsite&c=main&pid=taximaxim_site&is_retargeting=true',
    [Store.AppGallery]:
      'https://maximru-android.onelink.me/LIU9?af_r=https%3A%2F%2Fappgallery.cloud.huawei.com%2Fmarketshare%2Fapp%2FC116295649&c=main&pid=taximaxim_site&is_retargeting=true',
    [Store.RuStore]:
      'https://maximru-android.onelink.me/LIU9?af_r=https%3A%2F%2Fwww.rustore.ru%2Fcatalog%2Fapp%2Fcom.maxim.internal%26referrer%3Dutm_source%253Dtaximaxim%2526utm_medium%253Dsite&c=main&pid=taximaxim_site&is_retargeting=true',
  },
  site: 'https://taximaxim.ru',
  mapConfig: {
    region: AxiomMapRegion.Ru,
    [Themes.Light]: {
      trackLine: {
        color: '84, 110, 122',
      },
    },
    [Themes.Dark]: {
      trackLine: {
        color: '255, 202, 40',
      },
    },
  },
};
